import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { SectorsRoutingModule } from './sectors-routing.module';
import { SectorsComponent } from './sectors/sectors.component';
import { SectorsFilterComponent } from './sectors/sectors-filter/sectors-filter.component';
import { SectorsListComponent } from './sectors/sectors-list/sectors-list.component';
import { SectorsCreateComponent } from './sectors-create/sectors-create.component';
import { SectorsEditComponent } from './sectors-edit/sectors-edit.component';
import { SectorsCreateEditWidgetComponent } from './components/sectors-create-edit-widget/sectors-create-edit-widget.component';
import { SectorsService } from './sectors.service';
import { DistrictCoefficientsComponent } from './components/district-coefficients/district-coefficients.component';
import { SectorDistributionOptionsComponent } from './components/sector-distribution-options/sector-distribution-options.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { MonitoringFilterComponent } from './monitoring/monitoring-filter/monitoring-filter.component';

@NgModule({
  declarations: [
    SectorsComponent,
    SectorsFilterComponent,
    SectorsListComponent,
    SectorsCreateComponent,
    SectorsEditComponent,
    SectorsCreateEditWidgetComponent,
    DistrictCoefficientsComponent,
    SectorDistributionOptionsComponent,
    MonitoringComponent,
    MonitoringFilterComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AppUiModule, SharedModule, SectorsRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [SectorsService],
})
export class SectorsModule {}
